import { render, staticRenderFns } from "./PlayerPanel.vue?vue&type=template&id=117e045e&scoped=true"
import script from "./PlayerPanel.vue?vue&type=script&lang=js"
export * from "./PlayerPanel.vue?vue&type=script&lang=js"
import style0 from "./PlayerPanel.vue?vue&type=style&index=0&id=117e045e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e045e",
  null
  
)

export default component.exports